import {
  fetchEmail,
  fetchNotes,
  fetchActivities,
  fetchPulseLogs,
  fetchFiles,
  fetchLoadMoreFiles,
  clearFiles,
  fetchFilesTimeline,
  updateActivityFiles,
  bookmarkActivityFiles,
  deleteActivityFiles,
  loadMoreActivities,
  loadMoreNotes,
  loadMorePulseLogs,
  clearNotes,
  clearActivities,
  clearPulse,
  bookmarkActivity,
  deleteActivity,
  updateActivity,
  updateNote,
  bookmarkNote,
  deleteNote,
  updatePulse,
  deletePulse,
  bookmarkPulse,
  refreshPulse,
  refreshFiles,
  refreshActivities,
  refreshNotes,
  // fetchActivityByEmailMessages,
} from '../../routines';
import { fetchSurveyResponsesByEntity } from '../../routines/surveyRoutines';

const initialAttributes = {
  items: [],
  // activityData: {},
  loading: false,
  isSuccess: false,
};

const initialState = {
  activities: {
    ...initialAttributes,
    loading: false,
    loadingMore: false,
    paginationData: {},
    refresh: null,
    updateActivity: {
      loading: {},
      isSuccess: {},
    },
    deleteActivity: {
      loading: false,
      isSuccess: false,
    },
    bookmarkActivity: {
      loading: false,
      isSuccess: false,
    },
  },
  tasks: { ...initialAttributes },
  notes: {
    ...initialAttributes,
    loading: false,
    loadingMore: false,
    paginationData: {},
    refresh: null,
    updateNote: {
      loading: {},
      isSuccess: {},
    },
    deleteNote: {
      loading: false,
      isSuccess: false,
    },
    bookmarkNote: {
      loading: false,
      isSuccess: false,
    },
  },
  healthLogs: {
    ...initialAttributes,
    loading: false,
    loadingMore: false,
    paginationData: {},
    updateHealthLog: {
      loading: {},
      isSuccess: {},
    },
    deleteHealthLog: {
      loading: false,
      isSuccess: false,
    },
    bookmarkHealthLog: {
      loading: false,
      isSuccess: false,
    },
    refresh: null,
  },
  emails: { ...initialAttributes },
  files: {
    ...initialAttributes,
    filesPaginationData: {},
    selectedFile: null,
    hasMoreFiles: true,
    loadingMore: false,
    updating: false,
    bookmarking: false,
    deleting: false,
    refresh: null,
  },
  filesTimeline: {
    items: [],
    loadingFilesTimeline: false,
    success: false,
  },
  surveys: { ...initialAttributes },
};

const entityActivityReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchEmail.TRIGGER:
      return {
        ...state,
        emails: {
          ...state.emails,
          loading: true,
          isSuccess: false,
        },
      };

    case fetchEmail.SUCCESS:
      return {
        ...state,
        emails: {
          ...state.emails,
          items: action.payload.emailThreads,
          loading: false,
          isSuccess: true,
        },
      };

    case fetchEmail.FAILURE:
      return {
        ...state,
        emails: {
          ...state.emails,
          items: [],
          loading: false,
          isSuccess: false,
        },
      };

    case fetchNotes.TRIGGER:
      return {
        ...state,
        notes: {
          ...state.notes,
          loading: true,
          isSuccess: false,
        },
      };

    case fetchNotes.SUCCESS: {
      const { data, ...paginationData } = action.payload;
      return {
        ...state,
        notes: {
          ...state.notes,
          items: data,
          paginationData,
          loading: false,
          isSuccess: true,
        },
      };
    }

    case fetchNotes.FAILURE:
      return {
        ...state,
        notes: {
          ...state.notes,
          items: [],
          loading: false,
          isSuccess: false,
        },
      };

    // load more activities
    case loadMoreNotes.TRIGGER:
      return {
        ...state,
        notes: {
          ...state.notes,
          loadingMore: true,
          isSuccess: false,
        },
      };

    case loadMoreNotes.SUCCESS: {
      const isNewPageFirst = action.payload.page === 1;
      return {
        ...state,
        notes: {
          ...state.notes,
          items: isNewPageFirst
            ? [...(action.payload.data ?? [])]
            : [...state.notes.items, ...(action.payload.data ?? [])],
          loadingMore: false,
          isSuccess: true,
        },
      };
    }

    case loadMoreNotes.FAILURE:
      return {
        ...state,
        notes: {
          ...state.notes,
          items: [],
          loadingMore: false,
          isSuccess: false,
        },
      };

    case clearNotes.TRIGGER:
      return {
        ...state,
        notes: {
          items: [],
          loading: false,
          isSuccess: false,
        },
      };

    case refreshNotes.TRIGGER: {
      return {
        ...state,
        notes: {
          ...state.notes,
          refresh: action.payload,
        },
      };
    }

    case bookmarkNote.TRIGGER: {
      const { noteId, formData } = action.payload;
      const { bookmarkStatus: bookmarked } = formData;
      const newNoteList = [...state.notes.items];
      const selectedNoteIndex = newNoteList.findIndex(
        ({ data: note }) => note.noteId === noteId
      );

      const _selectedNote = newNoteList[selectedNoteIndex];
      const updatedNote = {
        ...newNoteList[selectedNoteIndex].data,
        bookmarked,
      };

      newNoteList[selectedNoteIndex] = {
        ...newNoteList[selectedNoteIndex],
        data: updatedNote,
      };

      return {
        ...state,
        notes: {
          ...state.notes,
          selectedNote: _selectedNote,
          items: newNoteList,
        },
      };
    }

    case bookmarkNote.SUCCESS: {
      return {
        ...state,
        notes: {
          ...state.notes,
          selectedNote: null,
        },
      };
    }

    case bookmarkNote.FAILURE: {
      const { noteId } = action.payload;
      const newNotesList = [...state.notes.items];
      const selectedNoteIndex = newNotesList.findIndex(
        ({ data: note }) => note.noteId === noteId
      );

      const { selectedActivity } = state.activities;

      if (selectedNoteIndex !== -1) {
        const updatedNote = {
          ...newNotesList[selectedNoteIndex].data,
          bookmarked: selectedActivity.bookmarked,
        };
        newNotesList[selectedNoteIndex] = {
          ...newNotesList[selectedNoteIndex],
          ...updatedNote,
        };
      }

      return {
        ...state,
        healthLogs: {
          ...state.healthLogs,
          selectedActivity: null,
          items: newNotesList,
        },
      };
    }

    case deleteNote.TRIGGER: {
      const { noteId } = action.payload;

      return {
        ...state,
        notes: {
          ...state.notes,
          selectedNote: { noteId },
          deleteNote: {
            ...state.notes.deleteNote,
            loading: true,
            isSuccess: false,
          },
        },
      };
    }

    case deleteNote.SUCCESS: {
      const { selectedNote } = state.notes;
      const newNotesList = [...state.notes.items];

      const updatedNoteList = newNotesList.filter(
        ({ data: note }) => note.noteId !== selectedNote.noteId
      );

      return {
        ...state,
        notes: {
          ...state.notes,
          items: updatedNoteList,
          selectedNote: null,
          deleteNote: {
            ...state.notes.deleteNote,
            loading: false,
            isSuccess: true,
          },
        },
      };
    }

    case deleteNote.FAILURE:
      return {
        ...state,
        notes: {
          ...state.notes,
          items: [...state.notes.items],
          deleteNote: {
            ...state.notes.deleteNote,
            loading: false,
            isSuccess: false,
          },
        },
      };

    // Need Check
    case updateNote.TRIGGER: {
      return {
        ...state,
        notes: {
          ...state.notes,
          updateNote: {
            loading: {
              [action.payload.noteId]: true,
            },
            isSuccess: {
              [action.payload.noteId]: false,
            },
          },
        },
      };
    }

    case updateNote.SUCCESS: {
      const { noteId, response } = action.payload;

      const newNotesList = [...state.notes.items];
      const selectedNoteIndex = newNotesList.findIndex(
        ({ data: note }) => note.noteId === noteId
      );

      const updatedNote = {
        ...newNotesList[selectedNoteIndex].data,
        ...response.data,
      };

      newNotesList[selectedNoteIndex] = {
        ...newNotesList[selectedNoteIndex],
        data: updatedNote,
      };

      return {
        ...state,
        notes: {
          ...state.notes,
          items: newNotesList,
          updateNote: {
            loading: {
              [action.payload.noteId]: false,
            },
            isSuccess: {
              [action.payload.noteId]: true,
            },
          },
        },
      };
    }

    case updateNote.FAILURE:
      return {
        ...state,
        notes: {
          ...state.notes,
          items: [...state.notes.items],
          updateNote: {
            loading: {
              [action.payload.noteId]: false,
            },
            isSuccess: {
              [action.payload.noteId]: false,
            },
          },
        },
      };

    case fetchActivities.TRIGGER:
      return {
        ...state,
        activities: {
          ...state.activities,
          items: [],
          loading: true,
          isSuccess: false,
        },
      };

    case fetchActivities.SUCCESS: {
      const { data, ...paginationData } = action.payload;
      return {
        ...state,
        activities: {
          ...state.activities,
          items: data,
          paginationData,
          loading: false,
          isSuccess: true,
        },
      };
    }

    case fetchActivities.FAILURE:
      return {
        ...state,
        activities: {
          ...state.activities,
          items: [],
          loading: false,
          isSuccess: false,
        },
      };

    // load more activities
    case loadMoreActivities.TRIGGER:
      return {
        ...state,
        activities: {
          ...state.activities,
          loadingMore: true,
          isSuccess: false,
        },
      };

    case loadMoreActivities.SUCCESS: {
      const { data, ...paginationData } = action.payload;
      const isNewPageFirst = action.payload.page === 1;
      return {
        ...state,
        activities: {
          ...state.activities,
          items: isNewPageFirst
            ? [...(data ?? [])]
            : [...state.activities.items, ...(data ?? [])],
          paginationData,
          loadingMore: false,
          isSuccess: true,
        },
      };
    }

    case loadMoreActivities.FAILURE:
      return {
        ...state,
        activities: {
          ...state.activities,
          items: [],
          loadingMore: false,
          isSuccess: false,
        },
      };

    case clearActivities.TRIGGER:
      return {
        ...state,
        activities: {
          ...state.activities,
          items: [],
          loading: false,
          isSuccess: false,
        },
      };

    case refreshActivities.TRIGGER: {
      return {
        ...state,
        activities: {
          ...state.activities,
          refresh: action.payload,
        },
      };
    }

    case bookmarkActivity.TRIGGER: {
      const { activityId, formData } = action.payload;
      const { bookmarkStatus: bookmarked } = formData;
      const newActivityList = [...state.activities.items];
      const selectedActivityIndex = newActivityList.findIndex(
        ({ data: activity }) => activity.activityId === activityId
      );

      const _selectedActivity = newActivityList[selectedActivityIndex];
      const updatedActivity = {
        ...newActivityList[selectedActivityIndex].data,
        bookmarked,
      };

      newActivityList[selectedActivityIndex] = {
        ...newActivityList[selectedActivityIndex],
        data: updatedActivity,
      };

      return {
        ...state,
        activities: {
          ...state.activities,
          selectedActivity: _selectedActivity,
          items: newActivityList,
        },
      };
    }

    case bookmarkActivity.SUCCESS: {
      return {
        ...state,
        activities: {
          ...state.activities,
          selectedActivity: null,
        },
      };
    }

    case bookmarkActivity.FAILURE: {
      const { activityId } = action.payload;
      const newActivityList = [...state.healthLogs.items];
      const selectedActivityIndex = newActivityList.findIndex(
        ({ data: activity }) => activity.activityId === activityId
      );

      const { selectedActivity } = state.activities;

      if (selectedActivityIndex !== -1) {
        const updatedFile = {
          ...newActivityList[selectedActivityIndex].data,
          bookmarked: selectedActivity.bookmarked,
        };
        newActivityList[selectedActivityIndex] = {
          ...newActivityList[selectedActivityIndex],
          ...updatedFile,
        };
      }

      return {
        ...state,
        healthLogs: {
          ...state.healthLogs,
          selectedActivity: null,
          items: newActivityList,
        },
      };
    }

    case deleteActivity.TRIGGER: {
      const { activityId } = action.payload;

      return {
        ...state,
        activities: {
          ...state.activities,
          selectedActivity: { activityId },
          deleteActivity: {
            ...state.activities.deleteActivity,
            loading: true,
            isSuccess: false,
          },
        },
      };
    }

    case deleteActivity.SUCCESS: {
      const { selectedActivity } = state.activities;
      const newActivityList = [...state.activities.items];

      const updatedActivityList = newActivityList.filter(
        ({ data: activity }) =>
          activity.activityId !== selectedActivity.activityId
      );

      return {
        ...state,
        activities: {
          ...state.activities,
          items: updatedActivityList,
          selectedActivity: null,
          deleteActivity: {
            ...state.activities.deleteActivity,
            loading: false,
            isSuccess: true,
          },
        },
      };
    }

    case deleteActivity.FAILURE:
      return {
        ...state,
        activities: {
          ...state.activities,
          items: [...state.activities.items],
          deleteActivity: {
            ...state.activities.deleteActivity,
            loading: false,
            isSuccess: false,
          },
        },
      };

    case updateActivity.TRIGGER: {
      return {
        ...state,
        activities: {
          ...state.activities,
        },
      };
    }

    case updateActivity.SUCCESS: {
      const { activityId, response } = action.payload;

      const newActivityList = [...state.activities.items];
      const selectedActivityIndex = newActivityList.findIndex(
        ({ data: activity }) => activity.activityId === activityId
      );

      if (selectedActivityIndex !== -1) {
        const updatedActivity = {
          ...newActivityList[selectedActivityIndex],
          data: response.data,
        };
        newActivityList[selectedActivityIndex] = {
          ...newActivityList[selectedActivityIndex],
          ...updatedActivity,
        };
      }

      return {
        ...state,
        activities: {
          ...state.activities,
          selectedActivity: null,
          items: newActivityList,
          updateActivity: {
            loading: {
              [action.payload.activityId]: false,
            },
            isSuccess: {
              [action.payload.activityId]: true,
            },
          },
        },
      };
    }

    case updateActivity.FAILURE: {
      const { activityId } = action.payload;
      const newActivityList = [...state.activities.items];
      const selectedActivityIndex = newActivityList.findIndex(
        ({ data: activity }) => activity.activityId === activityId
      );
      const { selectedPulse } = state.healthLogs;

      if (selectedActivityIndex !== -1) {
        const updatedActivity = {
          ...newActivityList[selectedActivityIndex].data,
          ...selectedPulse.data,
        };
        newActivityList[selectedActivityIndex] = {
          ...newActivityList[selectedActivityIndex],
          data: updatedActivity,
        };
      }

      return {
        ...state,
        activities: {
          ...state.activities,
          selectedActivity: null,
          items: newActivityList,
          updateActivity: {
            loading: {
              [action.payload.activityId]: false,
            },
            isSuccess: {
              [action.payload.activityId]: false,
            },
          },
        },
      };
    }

    case fetchPulseLogs.TRIGGER:
      return {
        ...state,
        healthLogs: {
          ...state.healthLogs,
          loading: true,
          isSuccess: false,
        },
      };

    case fetchPulseLogs.SUCCESS: {
      const { data, ...paginationData } = action.payload;
      return {
        ...state,
        healthLogs: {
          ...state.healthLogs,
          items: data,
          paginationData,
          loading: false,
          isSuccess: true,
        },
      };
    }
    case fetchPulseLogs.FAILURE:
      return {
        ...state,
        healthLogs: {
          ...state.healthLogs,
          items: [],
          loading: false,
          isSuccess: false,
        },
      };

    case refreshPulse.TRIGGER: {
      return {
        ...state,
        healthLogs: {
          ...state.healthLogs,
          refresh: action.payload,
        },
      };
    }

    // load more health logs
    case loadMorePulseLogs.TRIGGER:
      return {
        ...state,
        healthLogs: {
          ...state.healthLogs,
          loadingMore: true,
          isSuccess: false,
        },
      };

    case loadMorePulseLogs.SUCCESS: {
      const { data, ...paginationData } = action.payload;
      const isNewPageFirst = action.payload.page === 1;
      return {
        ...state,
        healthLogs: {
          ...state.healthLogs,
          items: isNewPageFirst
            ? [...(action.payload.data ?? [])]
            : [...state.healthLogs.items, ...(action.payload.data ?? [])],
          paginationData,
          loadingMore: false,
          isSuccess: true,
        },
      };
    }

    case loadMorePulseLogs.FAILURE:
      return {
        ...state,
        healthLogs: {
          items: [],
          loadingMore: false,
          isSuccess: false,
        },
      };

    case bookmarkPulse.TRIGGER: {
      const { pulseId, formData } = action.payload;
      const { bookmarkStatus: bookmarked } = formData;
      const newPulseList = [...state.healthLogs.items];
      const selectedPulseIndex = newPulseList.findIndex(
        ({ data: pulse }) => pulse.pulseId === pulseId
      );

      const _selectedPulse = newPulseList[selectedPulseIndex];
      const updatedPulse = {
        ...newPulseList[selectedPulseIndex].data,
        bookmarked,
      };

      newPulseList[selectedPulseIndex] = {
        ...newPulseList[selectedPulseIndex],
        data: updatedPulse,
      };

      return {
        ...state,
        healthLogs: {
          ...state.healthLogs,
          selectedPulse: _selectedPulse,
          items: newPulseList,
        },
      };
    }

    case bookmarkPulse.SUCCESS: {
      return {
        ...state,
        healthLogs: {
          ...state.healthLogs,
          selectedFile: null,
        },
      };
    }

    case bookmarkPulse.FAILURE: {
      const { pulseId } = action.payload;
      const newPulseList = [...state.healthLogs.items];
      const selectedPulseIndex = newPulseList.findIndex(
        ({ data: pulse }) => pulse.pulseId === pulseId
      );

      const { selectedPulse } = state.healthLogs;

      if (selectedPulseIndex !== -1) {
        const updatedFile = {
          ...newPulseList[selectedPulseIndex].data,
          bookmarked: selectedPulse.bookmarked,
        };
        newPulseList[selectedPulseIndex] = {
          ...newPulseList[selectedPulseIndex],
          ...updatedFile,
        };
      }

      return {
        ...state,
        healthLogs: {
          ...state.healthLogs,
          selectedPulse: null,
          items: newPulseList,
          updateHealthLog: {
            loading: false,
            isSuccess: false,
          },
        },
      };
    }

    case deletePulse.TRIGGER: {
      const { pulseId } = action.payload;

      return {
        ...state,
        healthLogs: {
          ...state.healthLogs,
          selectedPulse: { pulseId },
          deletePulse: {
            ...state.healthLogs.deleteHealthLog,
            loading: true,
            isSuccess: false,
          },
        },
      };
    }

    case deletePulse.SUCCESS: {
      const { selectedPulse } = state.healthLogs;
      const newPulseList = [...state.healthLogs.items];

      const updatedPulseList = newPulseList.filter(
        ({ data: pulse }) => pulse.pulseId !== selectedPulse.pulseId
      );

      return {
        ...state,
        healthLogs: {
          ...state.healthLogs,
          items: updatedPulseList,
          selectedPulse: null,
          deletePulse: {
            ...state.healthLogs.deleteHealthLog,
            loading: false,
            isSuccess: true,
          },
        },
      };
    }

    case deletePulse.FAILURE:
      return {
        ...state,
        healthLogs: {
          ...state.healthLogs,
          items: [...state.healthLogs.items],
          deletePulse: {
            ...state.healthLogs.deleteHealthLog,
            loading: false,
            isSuccess: false,
          },
        },
      };

    case updatePulse.TRIGGER: {
      return {
        ...state,
        healthLogs: {
          ...state.healthLogs,
          items: state.healthLogs.items,
          updateHealthLog: {
            loading: {
              [action.payload.pulseId]: true,
            },
            isSuccess: {
              [action.payload.pulseId]: false,
            },
          },
        },
      };
    }

    case updatePulse.SUCCESS: {
      const { pulseId, response } = action.payload;

      const newFilesList = [...state.healthLogs.items];
      const selectedFileIndex = newFilesList.findIndex(
        ({ data: pulse }) => pulse.pulseId === pulseId
      );

      if (selectedFileIndex !== -1) {
        const updatedFile = {
          ...newFilesList[selectedFileIndex],
          data: response.data,
        };
        newFilesList[selectedFileIndex] = {
          ...newFilesList[selectedFileIndex],
          ...updatedFile,
        };
      }

      return {
        ...state,
        healthLogs: {
          ...state.healthLogs,
          selectedPulse: null,
          items: newFilesList,
          updateHealthLog: {
            loading: {
              [action.payload.pulseId]: false,
            },
            isSuccess: {
              [action.payload.pulseId]: true,
            },
          },
        },
      };
    }

    case updatePulse.FAILURE: {
      const { pulseId } = action.payload;
      const newFilesList = [...state.healthLogs.items];
      const selectedHealthLogIndex = newFilesList.findIndex(
        ({ data: pulse }) => pulse.pulseId === pulseId
      );
      const { selectedPulse } = state.healthLogs;

      if (selectedHealthLogIndex !== -1) {
        const updatedFile = {
          ...newFilesList[selectedHealthLogIndex].data,
          ...selectedPulse.data,
        };
        newFilesList[selectedHealthLogIndex] = {
          ...newFilesList[selectedHealthLogIndex],
          data: updatedFile,
        };
      }

      return {
        ...state,
        healthLogs: {
          ...state.healthLogs,
          selectedFile: null,
          items: newFilesList,
          updateHealthLog: {
            loading: {
              [action.payload.pulseId]: false,
            },
            isSuccess: {
              [action.payload.pulseId]: false,
            },
          },
        },
      };
    }

    case clearPulse.TRIGGER:
      return {
        ...state,
        healthLogs: {
          items: [],
          loading: false,
          isSuccess: false,
        },
      };

    case fetchFiles.TRIGGER:
      return {
        ...state,
        files: {
          ...state.files,
          loading: true,
          isSuccess: false,
        },
      };

    case fetchFiles.SUCCESS: {
      const { data, ...paginationData } = action.payload;
      const hasMoreFiles = paginationData.totalCount > data.length;
      return {
        ...state,
        files: {
          ...state.files,
          items: data,
          filesPaginationData: paginationData,
          loading: false,
          isSuccess: true,
          hasMoreFiles,
        },
      };
    }

    case fetchFiles.FAILURE:
      return {
        ...state,
        files: {
          ...state.files,
          items: [],
          loading: false,
          isSuccess: false,
        },
      };

    case fetchLoadMoreFiles.TRIGGER:
      return {
        ...state,
        files: {
          ...state.files,
          loadingMore: true,
        },
      };

    case fetchLoadMoreFiles.SUCCESS: {
      const { data, ...paginationData } = action.payload;
      const hasMoreFiles =
        paginationData.totalCount > state.files.items.length + data.length;
      return {
        ...state,
        files: {
          ...state.files,
          items: [...state.files.items, ...data],
          filesPaginationData: paginationData,
          loadingMore: false,
          isSuccess: true,
          hasMoreFiles,
        },
      };
    }

    case fetchLoadMoreFiles.FAILURE:
      return {
        ...state,
        files: {
          ...state.files,
          loadingMore: false,
          isSuccess: false,
        },
      };

    case fetchFilesTimeline.TRIGGER:
      return {
        ...state,
        filesTimeline: {
          ...state.filesTimeline,
          loadingFilesTimeline: true,
          success: false,
        },
      };

    case fetchFilesTimeline.SUCCESS:
      return {
        ...state,
        filesTimeline: {
          ...state.filesTimeline,
          items: action.payload.data,
          loadingFilesTimeline: false,
          success: true,
        },
      };

    case fetchFilesTimeline.FAILURE:
      return {
        ...state,
        filesTimeline: {
          ...state.filesTimeline,
          loadingFilesTimeline: false,
          success: false,
        },
      };

    case refreshFiles.TRIGGER: {
      return {
        ...state,
        files: {
          ...state.files,
          refresh: action.payload,
        },
      };
    }

    case updateActivityFiles.TRIGGER: {
      const { fileGroupId, comment } = action.payload;
      const newFilesList = [...state.files.items];
      const selectedFileIndex = newFilesList.findIndex(
        ({ data: file }) => file.fileGroupId === fileGroupId
      );

      const _selectedFile = newFilesList[selectedFileIndex];

      if (selectedFileIndex !== -1) {
        const updatedFile = {
          ...newFilesList[selectedFileIndex].data,
          comment,
        };
        newFilesList[selectedFileIndex] = {
          ...newFilesList[selectedFileIndex],
          data: updatedFile,
        };
      }

      return {
        ...state,
        files: {
          ...state.files,
          selectedFile: _selectedFile,
          items: newFilesList,
          updating: true,
        },
      };
    }

    case updateActivityFiles.SUCCESS: {
      const { fileGroupId, response } = action.payload;
      const { comment, modified } = response;

      const newFilesList = [...state.files.items];
      const selectedFileIndex = newFilesList.findIndex(
        ({ data: file }) => file.fileGroupId === fileGroupId
      );

      if (selectedFileIndex !== -1) {
        const updatedFile = {
          ...newFilesList[selectedFileIndex].data,
          comment,
          modified,
        };
        newFilesList[selectedFileIndex] = {
          ...newFilesList[selectedFileIndex],
          data: updatedFile,
        };
      }

      return {
        ...state,
        files: {
          ...state.files,
          selectedFile: null,
          items: newFilesList,
          updating: false,
        },
      };
    }

    case updateActivityFiles.FAILURE: {
      const { fileGroupId } = action.payload;
      const newFilesList = [...state.files.items];
      const selectedFileIndex = newFilesList.findIndex(
        ({ data: file }) => file.fileGroupId === fileGroupId
      );
      const { selectedFile } = state.files;

      if (selectedFileIndex !== -1) {
        const updatedFile = {
          ...newFilesList[selectedFileIndex].data,
          comment: selectedFile.comment,
        };
        newFilesList[selectedFileIndex] = {
          ...newFilesList[selectedFileIndex],
          data: updatedFile,
        };
      }

      return {
        ...state,
        files: {
          ...state.files,
          selectedFile: null,
          items: newFilesList,
          updating: false,
        },
      };
    }

    case bookmarkActivityFiles.TRIGGER: {
      const { fileGroupId, formData } = action.payload;
      const { bookmarked: bookmarkStatus } = formData;
      const newFilesList = [...state.files.items];
      const selectedFileIndex = newFilesList.findIndex(
        ({ data: file }) => file.fileGroupId === fileGroupId
      );

      const _selectedFile = newFilesList[selectedFileIndex];
      const updatedFile = {
        ...newFilesList[selectedFileIndex].data,
        bookmarked: bookmarkStatus,
      };

      newFilesList[selectedFileIndex] = {
        ...newFilesList[selectedFileIndex],
        data: updatedFile,
      };

      return {
        ...state,
        files: {
          ...state.files,
          selectedFile: _selectedFile,
          items: newFilesList,
          bookmarking: true,
        },
      };
    }

    case bookmarkActivityFiles.SUCCESS: {
      const { fileGroupId, bookmarked } = action.payload;
      const newFilesList = [...state.files.items];
      const selectedFileIndex = newFilesList.findIndex(
        ({ data: file }) => file.fileGroupId === fileGroupId
      );

      if (selectedFileIndex !== -1) {
        const updatedFile = {
          ...newFilesList[selectedFileIndex].data,
          bookmarked,
        };
        newFilesList[selectedFileIndex] = {
          ...newFilesList[selectedFileIndex],
          data: updatedFile,
        };
      }

      return {
        ...state,
        files: {
          ...state.files,
          selectedFile: null,
          items: newFilesList,
          bookmarking: false,
        },
      };
    }

    case bookmarkActivityFiles.FAILURE: {
      const { fileGroupId } = action.payload;
      const newFilesList = [...state.files.items];
      const selectedFileIndex = newFilesList.findIndex(
        ({ data: file }) => file.fileGroupId === fileGroupId
      );

      const { selectedFile } = state.files;

      if (selectedFileIndex !== -1) {
        const updatedFile = {
          ...newFilesList[selectedFileIndex].data,
          bookmarked: selectedFile.bookmarked,
        };
        newFilesList[selectedFileIndex] = {
          ...newFilesList[selectedFileIndex],
          data: updatedFile,
        };
      }

      return {
        ...state,
        files: {
          ...state.files,
          selectedFile: null,
          items: newFilesList,
          bookmarking: false,
        },
      };
    }

    case deleteActivityFiles.TRIGGER: {
      return {
        ...state,
        files: {
          ...state.files,
          deleting: true,
        },
      };
    }

    case deleteActivityFiles.SUCCESS: {
      const { fileGroupId } = action.payload;
      const newFilesList = [...state.files.items];
      const selectedFileIndex = newFilesList.findIndex(
        ({ data: file }) => file.fileGroupId === fileGroupId
      );

      if (selectedFileIndex !== -1) {
        newFilesList.filter(
          ({ data: file }) => file.fileGroupId !== fileGroupId
        );
      }

      return {
        ...state,
        files: {
          ...state.files,
          items: newFilesList,
          selectedFile: null,
          deleting: false,
        },
      };
    }

    case deleteActivityFiles.FAILURE: {
      return {
        ...state,
        files: {
          ...state.files,
          deleting: false,
        },
      };
    }

    case clearFiles.SUCCESS:
      return {
        ...state,
        files: {
          ...state.files,
          items: [],
          filesPaginationData: {},
          loading: false,
          isSuccess: true,
          hasMoreFiles: true,
        },
      };

    // case fetchActivityByEmailMessages.TRIGGER:
    //   return {
    //     ...state,
    //     emails: {
    //       ...state.emails,
    //       activityData: {
    //         loading: true,
    //         isSuccess: false,
    //       },
    //     },
    //   };
    //
    // case fetchActivityByEmailMessages.SUCCESS:
    //   return {
    //     ...state,
    //     emails: {
    //       ...state.emails,
    //       activityData: {
    //         data: action.payload.response.data,
    //         loading: false,
    //         isSuccess: true,
    //       },
    //     },
    //   };
    //
    // case fetchActivityByEmailMessages.FAILURE:
    //   return {
    //     ...state,
    //     emails: {
    //       ...state.emails,
    //       activityData: {
    //         loading: false,
    //         isSuccess: false,
    //         error: action.payload.error,
    //       },
    //     },
    //   };
    case fetchSurveyResponsesByEntity.TRIGGER:
      return {
        ...state,
        surveys: {
          ...state.surveys,
          loadingMore: true,
          isSuccess: false,
        },
      };

    case fetchSurveyResponsesByEntity.SUCCESS: {
      const combinedResponses = action.payload.npsResponses
        .concat(action.payload.csatResponses)
        .map((item) => ({
          data: item,
          orderBy: item.modified,
          type: 'surveys',
        }));

      return {
        ...state,
        surveys: {
          ...state.surveys,
          lastFetchedNPSKey: action.payload.lastFetchedNPSKey,
          lastFetchedCSATKey: action.payload.lastFetchedCSATKey,
          items: action.payload.preservePreviousList
            ? state.surveys.items.concat(combinedResponses)
            : combinedResponses,
          loadingMore: false,
          isSuccess: true,
        },
      };
    }

    case fetchSurveyResponsesByEntity.FAILURE:
      return {
        ...state,
        surveys: {
          ...state.surveys,
          items: [],
          loadingMore: false,
          isSuccess: false,
        },
      };
    default:
      return state;
  }
};

export default entityActivityReducer;
